import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconCar,
  IconCctvLine,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';
import subVideo1 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo4.mp4';
import subVideo5 from '@src/assets/images/solution/constructionSafety/video/sub/rtlsVideo5.mp4';

import image1 from '@src/assets/images/solution/constructionSafety/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSafety/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSafety/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSafety/img/4.avif';

export default {
  type: '建設ソリューション',
  banner: {
    title: '建設現場で作業者のリスクを即時検知して対応しましょう。',
    desc: '作業者の位置をリアルタイムで把握し、危険が発生した場合には即座に対応して現場の安全を強化します。',
  },

  video: {
    title: 'リアルタイム位置データで建設現場の安全管理を最適化。',
    desc: '現場作業者のリアルタイム位置を高精度で追跡し、リスクを事前に察知して迅速に対応できます。これにより現場運営の安全性と効率性を向上させます。',
    play: mainVideo,
  },

  func: [
    {
      theme: '作業者の位置をリアルタイムで監視し、事故リスクを最小化しましょう。',
      title: '作業者位置のリアルタイム追跡',
      desc: '作業者の現在位置を±50cm以内の高精度でリアルタイムに把握し、現場内の事故リスクを即時に検知します。これにより、迅速な事故対応と予防措置が可能です。',
      sub1: '高精度追跡',
      icon1: IconRulerGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      video: subVideo1,
    },
    {
      title: '危険エリア侵入時自動アラート',
      desc: '作業者が指定された危険エリアに接近または侵入すると、管理者に即座に通知されます。これにより現場の安全を確保し、潜在的な事故を防ぎます。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '迅速なデータ連携',
      icon2: IconTvocGray,
      video: subVideo2,
    },
    {
      title: '重機位置の同時確認',
      desc: '重機にも位置追跡タグを装着し、機器の移動経路と現在位置を作業者と一緒に一元管理します。これにより重機と作業者の衝突リスクを低減し、機器運用効率も向上します。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高精度追跡',
      icon2: IconRulerGray,
      video: subVideo3,
    },
    {
      title: '作業者移動履歴記録と事故予防',
      desc: '作業者の移動履歴を記録し、事故発生時には迅速な対応が可能です。また、危険経路を事前に分析し、安全管理計画に活用します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドにデータ保存',
      icon2: IconCloudCheckGray,
      video: subVideo4,
    },
    {
      theme: 'データで安全を記録し、より良い運用を始めましょう',
      title: 'CCTV連携による安全モニタリング',
      desc: '作業者の位置データと現場CCTV映像をリアルタイムで連携し、現場状況を即座に可視化します。危険発生時には作業者の位置と周辺状況をCCTVで確認し、迅速かつ正確に対応できます。',
      sub1: '自由な範囲設定',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image1,
    },
    {
      title: '自動化された安全管理レポート作成',
      desc: '毎日または毎週単位で安全管理レポートが自動生成され、管理者に提供されます。事故状況と予防措置の結果を体系的に整理し、効率的な管理が可能です。',
      sub1: '自由な範囲設定',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image2,
    },
    {
      title: '危険事例発生履歴データ分析',
      desc: '過去の危険事例と作業者の移動データを分析し、事故が多発するエリアと状況を明確に把握します。これを基に今後の安全管理計画を改善します。',
      sub1: '自由な範囲設定',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image3,
    },
    {
      title: '人員配置最適化サポート',
      desc: '作業者の密集度と移動データを分析し、現場の人員配置を最適化します。効率的な人員管理により運用コストを削減できます。',
      sub1: '自由な範囲設定',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  subfunc: {
    title: '主な機能概要',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: '作業者位置のリアルタイム追跡',
        desc: '作業者の位置を±50cm以内でリアルタイムかつ高精度に追跡します。',
      },
      {
        icon: IconWarning,
        title: '危険エリア侵入自動アラート',
        desc: '作業者が危険エリアに侵入すると、即座に管理者へ通知します。',
      },
      {
        icon: IconCar,
        title: '重機位置の同時モニタリング',
        desc: '重機と作業者の位置を同時に管理し、衝突リスクを回避します。',
      },
      {
        icon: IconRoute,
        title: '作業者移動履歴記録',
        desc: '作業者の移動履歴を自動で記録し、事故予防と迅速な対応に活用します。',
      },
      {
        icon: IconCctvLine,
        title: 'CCTV連携対応',
        desc: '作業者位置とCCTV映像を連携して現場状況をリアルタイムで可視化します。',
      },
      {
        icon: IconChartBar,
        title: '安全管理レポート作成',
        desc: '作業者の安全状況と事故データを自動で分析し、レポートを提供します。',
      },
      {
        icon: IconSearch,
        title: '人員密集状況管理',
        desc: '現場の人員密集度をリアルタイムで管理し、基準超過時に通知します。',
      },
      {
        icon: IconLayers,
        title: '人員配置最適化サポート',
        desc: '人員密集度を分析し、運用人員を効率的に配置します。',
      },
      {
        icon: IconAnalytics,
        title: '危険状況データ分析',
        desc: '過去の危険データを分析し、事故予防計画を立案します。',
      },
      {
        icon: IconSecurity,
        title: '安全監査対応履歴活用',
        desc: '作業者の位置と移動データを監査および規制対応資料として活用します。',
      },
    ],
  },
  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
